import type { TrainerCapability } from '@zeus/index'
import { can } from '~/helpers/auth/can'
import { useAuth } from '~/helpers/store/auth'

/** Le porteur connecté peut-il faire ce que la capacité désigne (#11) ? */
export function useCan(capability: TrainerCapability): boolean {
  return useAuth(state => can(state.payload?.role, state.capabilities, capability))
}
